import { render, staticRenderFns } from "./PostsContainer.vue?vue&type=template&id=2657c7c5"
import script from "./PostsContainer.vue?vue&type=script&lang=js"
export * from "./PostsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports